import React, { useEffect } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import Title from '../../components/Title';
import { Order } from '../../models/APIModels';
import { PastOrderCard } from '../../components/user/PastOrderCard';
import { OrderCardSkeleton } from '../../components/user/OrderCardSkeleton';
import { isOrderCompleted } from '../../utilities/OrderHelpers';
import SubmitButton from '../../components/SubmitButton';

interface LocationState {
  allOrders?: Order[];
  isLoading?: boolean;
}

function PastOrdersComponent({ history, location }: RouteComponentProps<{}, {}, LocationState>): JSX.Element {
  const locationState = location.state || {};
  const allOrders = locationState.allOrders || [];
  const isLoading = locationState.isLoading || false;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const completedOrders = allOrders.filter(order => isOrderCompleted(order));

  const handleViewOrderDetails = (orderId: number, orderType?: string, e?: React.MouseEvent) => {
    if (e) {
      e.stopPropagation();
    }
    if (orderType === 'removal') {
      history.push(`/removals/order/${orderId}`);
    } else {
      history.push(`/order/${orderId}`);
    }
  };

  return (
    <>
      <Title>Past Orders</Title>
      <p className="grey">Your completed orders</p>

      <div className="past-orders-section">
        {isLoading && completedOrders.length === 0 ? (
          <OrderCardSkeleton />
        ) : completedOrders.length > 0 ? (
          completedOrders.map((order) => (
            <PastOrderCard
              key={order.id}
              order={order}
              onViewDetails={(e) => handleViewOrderDetails(order.id, order.orderType, e)}
            />
          ))
        ) : (
          <div className="no-past-orders">
            <p>You don't have any completed orders yet.</p>
            <SubmitButton onClick={() => history.push('/')}>
              Make Your First Booking
            </SubmitButton>
          </div>
        )}
      </div>

      <div className="past-orders-back-btn">
        <SubmitButton onClick={() => history.push('/dashboard')}>
          Back to Dashboard
        </SubmitButton>
      </div>
    </>
  );
}

export default withRouter(PastOrdersComponent);

